import Vue from 'vue'
import store from './store'
import router from './router'
import App from './components/App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import animated from 'animate.css'
Vue.use(ElementUI)
Vue.use(animated)
//全局baseURL
import axios from 'axios'
axios.defaults.baseURL = '/api' //关键代码
axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.config.productionTip = false;
Vue.prototype.$addr = axios;

new Vue({
	router,
	store,
	axios,
	template: '<App/>',
	components: {
		App
	}
}).$mount('#app')

// 设置浏览器标题
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = "新华智慧物流平台"
  }
})



// WEBPACK FOOTER //
// ./src/main.js